"use client";

import { c as _c } from "react/compiler-runtime";
import { Tooltip } from "react-tooltip";
import { useEffect, useState } from "react";
import { useCopyToClipboard } from "react-use";
import CopyIcon from "@/components/utils/icons/CopyIcon";
import { TOOLTIP_STYLES } from "@/helpers/tooltip.helpers";
export default function ProfileActivityLogItemValueWithCopy(t0) {
  const $ = _c(23);
  const {
    title,
    value
  } = t0;
  const [isTouchScreen, setIsTouchScreen] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsTouchScreen(window.matchMedia("(pointer: coarse)").matches);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  const [, copyToClipboard] = useCopyToClipboard();
  const [titleToShow, setTitleToShow] = useState(title);
  let t3;
  if ($[2] !== copyToClipboard || $[3] !== title || $[4] !== value) {
    t3 = () => {
      copyToClipboard(value);
      setTitleToShow("Copied!");
      setTimeout(() => {
        setTitleToShow(title);
      }, 1000);
    };
    $[2] = copyToClipboard;
    $[3] = title;
    $[4] = value;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleCopy = t3;
  const t4 = titleToShow === "Copied!" ? "tw-text-primary-400" : "";
  let t5;
  if ($[6] !== t4 || $[7] !== titleToShow) {
    t5 = <span className={t4}>{titleToShow}</span>;
    $[6] = t4;
    $[7] = titleToShow;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = `${isTouchScreen ? "tw-block" : "tw-opacity-0 group-hover:tw-opacity-100"} tw-mx-1 tw-cursor-pointer tw-border-0 tw-bg-transparent tw-text-sm tw-font-semibold tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-200 focus:tw-outline-none`;
  const t7 = `copy-activity-${value}`;
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="tw-flex tw-h-5 tw-w-5 tw-flex-shrink-0 tw-items-center tw-justify-center lg:tw-h-4 lg:tw-w-4 [&>svg]:tw-h-full [&>svg]:tw-w-full"><CopyIcon /></div>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== handleCopy || $[11] !== t6 || $[12] !== t7) {
    t9 = <button onClick={handleCopy} className={t6} data-tooltip-id={t7}>{t8}</button>;
    $[10] = handleCopy;
    $[11] = t6;
    $[12] = t7;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== isTouchScreen || $[15] !== value) {
    t10 = !isTouchScreen && <Tooltip id={`copy-activity-${value}`} place="top" positionStrategy="fixed" offset={8} opacity={1} style={TOOLTIP_STYLES}><span className="tw-text-xs">Copy</span></Tooltip>;
    $[14] = isTouchScreen;
    $[15] = value;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t9) {
    t11 = <>{t9}{t10}</>;
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t5) {
    t12 = <span className="tw-group tw-inline-flex tw-h-6 tw-whitespace-nowrap tw-text-sm tw-font-medium tw-text-iron-300 lg:tw-text-base">{t5}{t11}</span>;
    $[20] = t11;
    $[21] = t5;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
}